export const MAINLINE = 'mainline';
export const SIDEBAR = 'sidebar';
